import React, { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine
} from "recharts";
import Moment from "moment";

export const LinceChartV2 = (props) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (!props.apiCalled) return;

    // Prepare data in a format Recharts can use
    const formattedData = props.month.map((month, index) => ({
      name: month,
      requests: props.requests[index] || 0,
      approved: props.approved[index] || 0
    }));

    setChartData(formattedData);
  }, [props.month, props.requests, props.approved, props.apiCalled]);

  // Custom tooltip to format values and enhance readability
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-chart-tooltip">
          <p className="tooltip-label">{`${label}`}</p>
          <div className="tooltip-content">
            <p className="tooltip-item requests">
              <span className="label">Total Requests: </span>
              <span className="value">{payload[0].value.toLocaleString()} Bath</span>
            </p>
            <p className="tooltip-item approved">
              <span className="label">Total Approved: </span>
              <span className="value">{payload[1].value.toLocaleString()} Bath</span>
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  // Custom formatter for the Y-axis values to show in thousands (K) or millions (M)
  const formatYAxis = (value) => {
    if (value === 0) return '0';
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `${(value / 1000).toFixed(1)}K`;
    }
    return value;
  };

  // Custom legend that provides better visual cues
  const CustomLegend = ({ payload }) => {
    return (
      <div className="chart-legend">
        {payload.map((entry, index) => (
          <div key={`legend-${index}`} className={`legend-item ${entry.dataKey}`}>
            <div 
              className="legend-color" 
              style={{ backgroundColor: entry.color }}
            />
            <span>{entry.value}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="chart-container">
      {/* <h4 className="chart-title">Requests Total Amount</h4> */}
      <div className="recharts-wrapper">
        <ResponsiveContainer width="100%" height={350}>
          <LineChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
            <XAxis 
              dataKey="name" 
              tick={{ fill: '#5E5873', fontSize: 12 }}
              axisLine={{ stroke: '#E0E0E0' }}
              tickLine={{ stroke: '#E0E0E0' }}
            />
            <YAxis 
              tickFormatter={formatYAxis}
              tick={{ fill: '#5E5873', fontSize: 12 }}
              axisLine={{ stroke: '#E0E0E0' }}
              tickLine={{ stroke: '#E0E0E0' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend content={<CustomLegend />} />
            <Line 
              type="monotone" 
              dataKey="approved" 
              stroke="#ff9800" 
              strokeWidth={3}
              dot={{ r: 6, fill: "#ff9800", strokeWidth: 2 }}
              activeDot={{ r: 8, fill: "#ff9800", stroke: "white", strokeWidth: 2 }}
              name="Total amount Approved"
            />
            <Line 
              type="monotone" 
              dataKey="requests" 
              stroke="#6610F2" 
              strokeWidth={3}
              dot={{ r: 6, fill: "#6610F2", strokeWidth: 2 }}
              activeDot={{ r: 8, fill: "#6610F2", stroke: "white", strokeWidth: 2 }}
              name="Total amount Requests"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default LinceChartV2;